/** 「データ取り込みの手順」説明モーダル（レポートデータ更新画面）。ⓘボタンから開く閲覧専用モーダル（確定処理なし）。 */
import React from 'react'
import { useModal, useModalExtra } from '../../../../_components/Modal'
import { useModifyClassList } from '../../../../common/utils/CSSUtils'

/** モーダル本文：ベースファイルを基準としたデータ取り込み手順の説明（【重要】警告＋4ステップ） */
export const DataImportGuideModal = () => {
  return (
    <div className="text-body text-caption-2 leading-6 text-left text-[#333]">
      <p className="m-0 mb-3">
        システムにデータを取り込む際は、「<strong className="blue1--text">ベースファイル</strong>
        」に登録された従業員が対象となります。以下の手順でデータを取り込んでください。
      </p>
      <div className="my-3 rounded border-l-4 border-[#FFC107] bg-[#FFF3CD] px-3 py-2.5 text-[#856404]">
        <p className="m-0 font-semibold">【重要】</p>
        <p className="m-0 mt-1">
          ベースファイルに登録されていない従業員のデータは、他のデータ分類（給与明細、勤務実績など）で設定していても取り込まれません。
        </p>
      </div>
      <ol className="m-0 mt-3 list-decimal pl-5 leading-6">
        <li className="mb-1.5">
          <strong>ファイルをアップロード</strong> — 「ファイルを管理」からデータファイルをアップロードします。
        </li>
        <li className="mb-1.5">
          <strong>ファイル種別とベースファイルを設定</strong> —
          各ファイルにファイル種別・キー項目を設定します。あわせて、取り込みの基準とする従業員を含むファイルを「ベースファイル」として登録します（複数登録可）。
        </li>
        <li className="mb-1.5">
          <strong>マッピング設定とデータ検証</strong> —
          取り込みたいデータ種類のマッピングを設定を行い、データ検証を実行します。
        </li>
        <li>
          <strong>データ更新</strong> —
          「データ更新」を実行すると、データ検証まで完了したデータのみが各ダッシュボードに反映されます。未設定や設定中、検証待ち、再検証待ちのデータは取り込まれません。
        </li>
      </ol>
    </div>
  )
}

/**
 * 「データ取り込みの手順」モーダルを開くフック。他の確認モーダルフックと同様 `{ open… }` で揃え、呼び出し側の見通しをよくする。
 *
 * @returns {{ openDataImportGuideModal: () => Promise<void> }}
 */
export const useDataImportGuideModal = () => {
  const showModal = useModal()
  const { _closeUpModal } = useModalExtra()
  const { promisify } = useModifyClassList('.modal-window', ['w-[900px]'])

  const openDataImportGuideModal = () => {
    return promisify((res) => {
      showModal({
        title: 'データ取り込みの手順',
        description: null,
        isCancel: false,
        isWide: false,
        isSpinnerDisabled: true,
        onClose: res,
        body: <DataImportGuideModal />,
        button: [
          {
            name: '閉じる',
            className: 'footer-btn button_base',
            close: false,
            click: () => {
              _closeUpModal()
              res()
            }
          }
        ]
      })
    })
  }

  return { openDataImportGuideModal }
}
